// extracted by mini-css-extract-plugin
export default {"or-login-with-divider":"DdEae","identity-provider-error":"TaZau"};